<template>
    <div>
        <div v-if="isLoggedIn && currentAccessLevel != 'unknown'">
            <div v-if="years" class="comments-container">
                <div class="comments-title-section">
                    <div class="comments-title">
                        Comments
                    </div>
                    <div v-if="!renderDeleteCommentsLayout" class="comments-top-actions">
                        <!-- <div><button @click="deleteCommetsHandler()" v-if="currentAccessLevel == 'admin' || currentAccessLevel == 'poweruser'" class="btn btn-light-arp">Delete Comments</button></div> -->
                        <div><button  v-if="(currentAccessLevel == 'admin' || currentAccessLevel == 'poweruser')" class="btn btn-light-arp"  @click="onExportClick()">Export CSV</button></div>
                        <div><button style="'background-color': #FBC743 !important; border-radius:5px;" v-if="currentAccessLevel == 'admin' || currentAccessLevel == 'poweruser'" class="btn btn-warning-arp" @click="addNewComment()"><i class="fa fa-plus" style="margin-right:8px;" aria-hidden="true"></i>Add New Comment</button></div>
                    </div>
                    <div v-if="renderDeleteCommentsLayout" class="comments-top-actions">
                        <div style="color: #A4ADB3; padding-right: 8px;"> {{this.deleteSelections.length}} Comments Selected </div>
                        <div><button  v-if="currentAccessLevel == 'admin' || currentAccessLevel == 'poweruser'" class="btn btn-light-arp"  @click="cancelDeleteLayout()">Cancel</button></div>
                        <div><button style="'background-color': #FBC743 !important" v-if="currentAccessLevel == 'admin' || currentAccessLevel == 'poweruser'" class="btn btn-warning-arp" @click="onDeleteSelections()">Delete selected Comments</button></div>
                    </div>
                </div>
                <div class="container-fluid comments-view-section">
                    <div class="row">
                        <div class="col-3">
                            <b-card>
                                <div class="selection-title">
                                    <div style="font-size: 18px; font-weight: 600;"> Filters </div>
                                    <div style="color: #2B779B; font-size: 16px; font-weight: 600; cursor: pointer; padding: 3px 10px;" @click="clearFilters()"> CLEAR FILTER </div>
                                </div>
                                <div class="selection-container">
                                    <div>
                                        <div class="filter-label">Year</div>
                                        <div style="margin-bottom:1px;width:195px;">
                                         <datepicker :calendar-class="'vdp-datepicker'" :value="modalSelectedYear" 
                                                v-model="modalSelectedYear" placeholder="Select Year" @selected="setYear()" 
                                                @opened="displayRequiredYears()" 
                                                name="years"  :minimum-view="'year'" :format="'YYYY'" :maximum-view="'year'" 
                                                :initial-view="'year'" :disabled-dates="disabledDates">
                                        </datepicker>
                                        </div>
                                    </div>
                                        <div class="maincategory-filter">
                                            <div class="filter-label maincategory-label" style = "margin-top: 20px;">
                                                View Comments For
                                            </div>
                                             <div class="period-radio-group">
                                                     <label for="program" class="radio" >
                                                     <input type="radio" name="viewCommentsFor" class="hidden" id="program" :checked="selectedMainCategory === 'Providers'" key="providers" v-model="selectedMainCategory" value="Providers"/>
                                                     <span class="label"></span>Program
                                                     </label>
                                                  <label for="vertical" class="radio" >
                                                     <input type="radio" name="viewCommentsFor" class="hidden" id="vertical" :checked="selectedMainCategory === 'Verticals'" key="vertical" v-model="selectedMainCategory" value="Verticals"/>
                                                     <span class="label"></span>Vertical
                                                     </label>
                                                </div>
                                        </div>
                                        <div v-if="selectedMainCategory || true" class="subCategory-filter">
                                            <div style="height: 23px;" class="filter-label">
                                                {{selectedMainCategory === 'Providers' ? 'Program Name' : selectedMainCategory === 'Verticals' ? 'Vertical Name' : '' }}
                                            </div>
                                            <div>
                                                <select class="form-control"  v-model="selectedSubCategory">
                                                    <option v-if="selectedMainCategory == 'Program'" value="">Select Program</option>
                                                    <option v-else-if="selectedMainCategory === 'Verticals'" value="">Select Vertical</option>
                                                    <option v-else value="">Select Main Category</option>
                                                    <option v-for="subCategory in subCategories" :value="subCategory" :key="subCategory">{{subCategory}}</option>
                                                </select>
                                            </div>
                                        </div>
                                    <div v-if="selectedSubCategory || true" style="min-height: 221px;">
                                        <div class="period-filter">
                                            <div class="filter-label">Period</div>
                                                <div class="period-radio-group">
                                                    <label for="month" class="radio" >
                                                        <input type="radio" name="period"  class="hidden" id="month" :checked="periodSelector === 'Month'"  @click="handlePeriodRadioSelection" key="Month" value="Month"/>
                                                        <span class="label"></span>Month
                                                    </label>
                                                    <label for="quarter" class="radio">
                                                        <input type="radio" name="period" class="hidden"  id="quarter" :checked="periodSelector === 'Quarter'"  @click="handlePeriodRadioSelection" key="Quarter" value="Quarter"/>
                                                        <span class="label"></span>Quarter
                                                    </label>
                                                    <label for="annual" class="radio">
                                                        <input type="radio" name="period" class="hidden"  id="annual" :checked="periodSelector === 'Annual'"  @click="handlePeriodRadioSelection" key="Annual" value="Annual"/> 
                                                        <span class="label"></span>Annual
                                                    </label>
                                                    <label for="all" class="radio">
                                                        <input type="radio" name="period" class="hidden" id="all" :checked="periodSelector === 'All'" @click="handlePeriodRadioSelection"  key="All" value="All"/>
                                                        <span class="label"></span>All
                                                    </label>
                                                </div>
                                                <div v-bind:class="[(periodSelector === 'Month' || periodSelector === 'Quarter') ? 'subCategory-filter' : '']" :v-if="periodSelector === 'Month' || periodSelector === 'Quarter'">
                                                    <div :v-if="periodSelector === 'Month' || periodSelector === 'Quarter'" v-bind:class="[(periodSelector === 'Month' || periodSelector === 'Quarter') ? 'filter-label' : 'no-display']">
                                                        {{periodSelector}}
                                                    </div>
                                                    <div v-if="periodSelector === 'Month'">
                                                        <select class="form-control" v-model="selectedPeriod">
                                                            <option value="">Select Month </option>
                                                            <option v-for="period in mPeriods" :key="period" :value="period">{{period}}</option>
                                                        </select>
                                                    </div>
                                                    <div v-if="periodSelector === 'Quarter'">
                                                        <select class="form-control" v-model="selectedPeriod">
                                                            <option value="">Select Quarter
                                                                 </option>
                                                            <option v-for="period in qPeriods" :key="period" :value="period">{{period}}</option>
                                                        </select>
                                                    </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <button @click="onSubmit()" style="font-size: 18px; font-weight: 600; width:100%; border-radius:5px" class="btn btn-warning-arp">Apply Filters</button>
                            </b-card>
                        </div>
                        <div class="col-9 comment-view-container border-bottom">
                            <span>
                                <div class="row">
                                    <div style="width: 100%">
                                        <div v-if="waitingForData">
                                            Please Wait ...
                                        </div>
                                        <div v-else>
                                            <div v-if="commentsData[0]" class="col-12 someclass">
                                                <div class="comments-count" style="font-weight: 600;">{{ commentsData.length }} Comments</div>
                                                <div class="deleteSelectAll" v-if="renderDeleteCommentsLayout">
                                                    <input type="checkbox" @click="onDeleteSelectAll()" /> <span style="padding-left: 4px; color: #A4ADB3;">Select All</span>
                                                </div>
                                                    <b-card no-body class="overflow-hidden b-card"  v-for="(comment, index) in commentsData"  :key="index">
                                                        <b-row no-gutters>
                                                        <b-col md="2" class="leftContent" style="padding-left:25px;">
                                                           <div v-if="renderDeleteCommentsLayout" class="delete-checkbox">
                                                                <input type="checkbox" :checked="deleteAll" @click="addRemoveDeleteSelection(comment, index)"/>
                                                            </div>
                                                            <div> <span class="lable-lite"> Program: </span> <br /> {{String(comment.program_name).replace(/_/g," ").replace(/\d+/g, '')}}</div>
                                                            <div style="padding-top:25px"> <span class="lable-lite"> Period: </span> <br />
                                                                {{comment.period | titleCase}}
                                                                <!-- Below is the change to append year after period. -->
                                                                <!-- The code can break if the 'timeStamp' date format does not match "MMM DD YYYY hh:mmA" pattern. -->
                                                                <!-- {{comment.period | titleCase}}, {{[comment.timeStamp, "MMM DD YYYY hh:mmA"] | moment("YYYY")}} -->
                                                            </div>
                                                        </b-col>
                                                        <b-col md="9" class="middleContent" style="padding-left:25px">
                                                             <b-row>
                                                                  <b-col md="8">
                                                                    <div class="user-name-section">
                                                                    <div class="avatar-circle" 
                                                                    v-bind:style="{backgroundColor: comment.avatarBg ? comment.avatarBg : userAvatarPlaceHolders[Math.floor(Math.random() * userAvatarPlaceHolders.length)]}">
                                                                        <span class="initials">{{comment.firstName.slice(0,1)}}{{comment.lastName.slice(0,1)}}</span>
                                                                    </div>
                                                                <div>
                                                                    <div>{{comment.firstName}} {{comment.lastName}}</div>
                                                                    <div class="lable-lite">{{comment.userEmail}}</div>
                                                                </div>
                                                                </div>
                                                                </b-col>
                                                                <!-- todo the Data for comment.timeStamp should have space before 10:30 AM in time to work as per the format required-->
                                                                <b-col md="4">
                                                                <div class="lable-lite middleContent-corner" style="">
                                                                    {{comment.timeStamp | moment("On DD MMM, YYYY [at] hh:mm A")}}
                                                                    <!-- Below is the to change date format. -->
                                                                    <!-- The code can break if the 'timeStamp' date format does not match "MMM DD YYYY hh:mmA" pattern. -->
                                                                    <!-- {{[comment.timeStamp, "MMM DD YYYY hh:mmA"] | moment("On D MMM, YYYY [at] hh:mm A")}} -->
                                                                    </div>
                                                             </b-col>
                                                             </b-row>
                                                             <b-row>
                                                                 <b-col md="12" style="padding-bottom:10px;">
                                                                 <div class="main-comment"><pre class="format-pre">{{comment.comment}}</pre></div>
                                                                 <div class="commentLatestEdit" v-if="comment && comment.latest_editor_email && comment.latest_editor_fName && comment.latest_editor_lName">
                                                                    <img class="conf-img time-white" src="../assets/img/time-white.svg" alt="Time-white" />
                                                                    <div class="lable-lite">Last Updated By : 
                                                                        <span class="editorName">{{comment.latest_editor_fName}} {{comment.latest_editor_lName}}</span>
                                                                        <span class="editorEmail">({{comment.latest_editor_email}})</span>
                                                                    </div>
                                                                 </div>
                                                                 </b-col>
                                                             </b-row>
                                                        </b-col>
                                                        <b-col md="1" class="rightContent" v-if="currentAccessLevel != 'readonly' ">
                                                              <div id="commentActions" class="dot-menu" >
                                                                    <div @click="handleCommentMenuClick(index)" v-if="showCommentAtionMenu !== index">
                                                                        <span class="dot"></span>
                                                                        <span class="dot"></span>
                                                                        <span class="dot"></span>
                                                                    </div>
                                                                    <div v-else-if="showCommentAtionMenu === index">
                                                                        <div @mouseleave="handleCommentMenuClick(false)" class="comment-action-menu">
                                                                            <div class="menu-item" @click="editComment(comment,index)">Edit</div>
                                                                            <div class="menu-item" @click="deleteComment(comment, index)">Delete</div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                        </b-col>
                                                        </b-row>
                                                    </b-card>
                                                </div>
                                            <div class="noResultContainer" v-else>
                                                <img class="conf-img" src="../assets/img/no-results-found.png" alt="AARP Logo" />
                                                <div value="" style="font-size: 35px; color: ##303030">No results found </div>
                                                <div value="" style="font-size: 20px; color: #bfbfbf">Try adjusting your filter to find what you're looking for </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
        <div v-else>
            <div class="jumbotron jumbotron-fluid">
                <div class="container">
                    <!-- <h1 class="display-4">Program Analysis & Reports</h1> -->
                    <br>
                    <div v-if="isLoggedIn">
                        
                        <p class="lead">You don't have sufficient permissions to access this information. Please Contact the administrator</p>
                    </div>
                    <div v-else>
                        <p class="lead"> Please Login to continue.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters} from "vuex"
import Datepicker from '@hokify/vuejs-datepicker';

export default {
    name: "Commentary",
    components:{
        'datepicker':Datepicker
    },
   filters: {
        titleCase: function (str) {
            return str.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
        }
   },
    methods: {
        ...mapActions(['login','getCommentsData','fetchExportFile','initDeleteComment','updateCommentaryParams','updateComments','getMenuOptions','updateOverlayParams']),
        onSubmit(){
            var validation = this.validateViewComments()
            console.log(`logging onSubmit() validation: ${JSON.stringify(validation)}`)
            let selectedYear=new Date(this.modalSelectedYear).getUTCFullYear().toString();
            if(validation['status'] == true){
                var model = {
                    "mainCategory":this.selectedMainCategory,
                    "subCategory":this.selectedSubCategory,
                    "year":selectedYear,
                    "period":this.selectedPeriod,
                }
                this.waitingForData = true
                this.updateCommentaryParams({...model, periodSelector: this.periodSelector});
                this.getCommentsData()
            } else {
                this.updateOverlayParams({
                    display: 'block',
                    message: validation['message'],
                    // specialClassNames: 'download-in-progress',
                    isNotification: false,
                    buttons: {
                        type: 'alert',
                        successHandler: () => {}
                    },
                    specialClassNames: 'delete-comment',
                    duration: '',
                    displayCloseIcon: true,
                    background: true
                });
            }
        },
        clearFilters() {
            this.selectedMainCategory = '';
            this.selectedSubCategory = '';
            this.modalSelectedYear = '';
            this.selectedPeriod = '';
            this.periodSelector = '';
            this.commentsData = [];
            this.updateCommentaryParams({});
        },
        onExportClick(){
            var validation = this.validateViewComments()
            console.log(`logging onSubmit() validation: ${JSON.stringify(validation)}`)
            if(validation['status'] == true){
                var model = {
                    "mainCategory":this.selectedMainCategory,
                    "subCategory":this.selectedSubCategory,
                    "year":this.selectedYear,
                    "period":this.selectedPeriod,
                }
                // this.waitingForData = true
                this.updateCommentaryParams({...model, periodSelector: this.periodSelector})
                this.$notify({
                        group: 'inprogress',
                        text: 'Preparing to download...',
                        closeOnClick:true
                        });
                this.fetchExportFile()
            } else {
                this.updateOverlayParams({
                    display: 'block',
                    message: 'Select Program/Vertical and Period to export CSV.',
                    // specialClassNames: 'download-in-progress',
                    isNotification: false,
                    buttons: {
                        type: 'alert',
                        successHandler: () => {}
                    },
                    specialClassNames: 'delete-comment',
                    duration: '',
                    displayCloseIcon: true,
                    background: true
                });
            }
            
        },
        handleCommentMenuClick(index) {
            this.showCommentAtionMenu = index;
        },
        handlePeriodRadioSelection(e) {
            const val = e.target.value;
            if (val === 'All') {
                this.selectedPeriod = 'All';
                this.periodSelector = 'All'
            } else if (val === 'Annual') {
                this.selectedPeriod = 'Annual';
                this.periodSelector = 'Annual'
            } else {
                this.periodSelector = val;
                this.selectedPeriod = '';
            }
        },
        deleteComment(comment, index) {
            this.updateOverlayParams({
                    display: 'block',
                    title: 'Delete Comment',
                    message: 'Are you sure you want to delete this comment?',
                    // specialClassNames: 'download-in-progress',
                    isNotification: false,
                    buttons: {
                        type: 'challenge',
                        successHandler: () => {
                            let targetComment = {
                                //mainCategory: this.selectedMainCategory, 
                                programName: comment.program_name,
                                // this.selectedSubCategory, 
                                year: this.selectedYear, 
                                //period: this.selectedPeriod, 
                                //programName: this.modalSelectedProgram,
                                comment: comment.comment,
                                uuid: comment.uuid
                            };
                            const metaData = {
                                programName: this.selectedSubCategory,
                                year: this.selectedYear
                                };
                            this.initDeleteComment([targetComment]);
                        }
                    },
                    specialClassNames: 'delete-comment delete-modal',
                    duration: '',
                    displayCloseIcon: true,
                    background: true
                });
        },
        addComment(){
            var validation = this.validateAddComments()
            console.log(`logging addComment() validation: ${JSON.stringify(validation)}`)
            if(validation['status'] == true){
                var blob = {
                    "program": this.modalSelectedProgram,
                    "year": this.modalSelectedYear,
                    "period":this.modalSelectedPeriod,
                    "comment": this.modalTextArea.trim(),
                    "userEmail": this.currentUserEmail,
                    "timeStamp": Date().toLocaleString("en-us")
                    }
                console.log(blob)
                this.updateComments(blob)
                this.waitingForData = true
            } else {
                alert(validation['message'])
            } 
        },
        editComment(comment, index) {
            console.log(index, comment);
          
            let commentEx = {...comment, metaData: {
                mainCategory: this.selectedMainCategory,
                subCategory: this.selectedSubCategory,
                selectedYear: this.selectedYear,
                selectedPeriod: comment.period,
                selectedProgram: this.modalSelectedProgram,
                uuid: ''
            }}
            this.$router.push({name: 'editComment', params:{ comment: JSON.stringify(commentEx) }})
            // <router-link :to="{ name: 'Page2', params: { id: 1234 }, query: { debug: true }}">Navigate to Page2</router-link>
        },
        addNewComment() {
            this.$router.push({name: 'editComment', params:{ comment: JSON.stringify({addNew: true}) }})
        },
        validateAddComments(){
            console.log(`Validation addComments year: ${this.modalSelectedProgram}, program: ${this.modalSelectedProgram}, period: ${this.modalSelectedPeriod}, text: ${this.modalTextArea}`)
            if(this.modalSelectedYear.length != 0) {
                if(this.modalSelectedProgram.length != 0){
                    if(this.modalSelectedPeriod.length != 0){
                        if(this.modalTextArea.length != 0){
                            if(String(this.modalTextArea).trim().length >= 5 ){
                                return { 'status': true}
                            } else return { 'status': false, 'message': 'Please enter atleast 5 characters in the notes/comments section'}
                        } else return { 'status': false, 'message': "Please enter your notes, comments before you proceed"}
                    } else return { 'status': false, 'message': 'Please select a valid period before you proceed' }
                } else return { 'status': false, 'message': 'Please select a valid program/vertical before you proceed'}
            } else return { 'status': false, 'message': 'Please select a valid year before you proceed'}
        },
        validateViewComments(){
            console.log(`Validation viewComments() year: ${this.selectedYear}, mainCategory: ${this.selectedMainCategory}, subCategory: ${this.selectedSubCategory}, text: ${this.selectedPeriod}`)
            if(this.modalSelectedYear.length != 0) {
                if(this.selectedMainCategory.length != 0){
                    if(this.selectedSubCategory.length != 0){
                        if(this.selectedPeriod.length != 0){
                            return { 'status': true }
                        } else return { 'status': false, 'message': "Please select a valid period before you proceed"}
                    } else return { 'status': false, 'message': 'Please select a valid program/vertical name before you proceed' }
                } else return { 'status': false, 'message': 'Please select a valid program/vertical before you proceed'}
            } else return { 'status': false, 'message': 'Please select a valid year before you proceed'}
        },
        deleteCommetsHandler() {
            this.renderDeleteCommentsLayout = true;
        },
        getDeleteOverlayMessage(count) {
           let msg = count > 1 ? `${count} comments?` : `${count} comment?`;
           return msg;
        },
        onDeleteSelections() {
            console.log('@@@@@@@@@@', this.deleteSelections);
            if (!this.deleteSelections || this.deleteSelections.length === 0) {
                return;
            }
             this.updateOverlayParams({
                    display: 'block',
                    title: 'Delete Comment',
                    message: `Are you sure you want to delete the selected ${this.getDeleteOverlayMessage(this.deleteSelections.length)}`,
                    // specialClassNames: 'download-in-progress',
                    isNotification: false,
                    buttons: {
                        type: 'challenge',
                        successHandler: () => {
                            let targetComments = this.deleteSelections.map(e => {
                                return {
                                     //mainCategory: this.selectedMainCategory, 
                                    programName: this.selectedSubCategory, 
                                    year: this.selectedYear, 
                                    //period: this.selectedPeriod, 
                                    //programName: this.modalSelectedProgram,
                                    uuid: e.uuid
                                }
                            });
                            this.initDeleteComment(targetComments);
                        }
                    },
                    specialClassNames: 'delete-comment',
                    duration: '',
                    displayCloseIcon: true,
                    background: true
                });
        },
        cancelDeleteLayout() {
            this.renderDeleteCommentsLayout = false;
            this.deleteAll = false;
            this.deleteSelections = [];
        },
        removeSelection(i) {
            this.deleteSelections = this.deleteSelections.filter(e => e != i);
        },
        addRemoveDeleteSelection(comment, index) {
            this.deleteSelections.indexOf(index) > -1 ? this.removeSelection(index) : this.deleteSelections.push(index);
        },
        onDeleteSelectAll() {
            this.deleteAll = !this.deleteAll;
            if (this.deleteAll && this.commentsData && this.commentsData.length) {
                this.deleteSelections = [];
                this.commentsData.forEach((e, i) => {
                    this.addRemoveDeleteSelection(e, i);
                })
            }
            if (!this.deleteAll) {
                this.deleteSelections = [];
            }
        },
        setYear(){ 
            this.modalSelectedYear=new Date().getUTCFullYear().toString()
         },
        displayRequiredYears(){
            let years=JSON.stringify(Object.keys(this.years))
            this.disabledDates.customPredictor= function(date) {
            if(years.toString().includes(date.getFullYear())){
                    return false;
                }
                else{
                    return true;
                }
        }
        },
    },
    computed: mapGetters(['currentCommentsMainCategory','currentCommentsSubCategory','currentCommentsYear','currentCommentsPeriod','currentCommentsData','isLoggedIn','currentUserName','currentUserEmail','currentUserGroups','currentAccessLevel','currentCommentaryMenu', 'isExportInProgress','currentPeriodSelector']),
    data: function(){
        return {
            commentsData : false,
            years: false,
            // years: {'Loading...': {}},
            periods: ['January','February','March','April','May','June','July','August','September','October','November','December','Q1','Q2','Q3','Q4','Annual','All'],
            mPeriods: ['January','February','March','April','May','June','July','August','September','October','November','December'],
            qPeriods: ['Q1','Q2','Q3','Q4'],
            mainCategories: [],
            subCategories: [],
            selectedYear: "",
            selectedMainCategory: "",
            selectedSubCategory: "",
            selectedPeriod:"",
            modalPrograms:[],
            modalSelectedProgram:"",
            modalSelectedYear:"",
            modalSelectedPeriod:"",
            modalTextArea: "",
            modalShow: false,
            waitingForData: false,
            displayMainCategory: "",
            displaySubCategory: "",
            displayPeriod: "",
            displayYear: "",
            initialSetupCompleted: false,
            userAvatarPlaceHolders: ['#419393', '#9B469B', '#18C38A', '#F8C169', '#A12118'],
            showCommentAtionMenu: false,
            periodSelector: '',
            renderDeleteCommentsLayout: false,
            deleteSelections: [],
            deleteAll: false,
            disabledDates:{ customPredictor: function(date) {
                if(typeof this.years!=='undefined'){
            if(this.years.toString().includes(date.getFullYear())){
                    return false;
                }
                else{
                    return true;
                }
            }}},
        }
    },
    watch: {
        currentPeriodSelector: function() {
             this.handlePeriodRadioSelection({
                target: {
                    value: this.currentPeriodSelector
                }
            });
        },
        subCategories: function() {},
        selectedYear: function(){  
            // Clear previously selected values
            /*this.mainCategories = [];
            this.subCategories = [];
            this.selectedMainCategory = "";
            this.selectedSubCategory = "";  */

            // Populate list of mainCategories based on year in the second dropdown
            if (this.selectedYear.length > 0){
                this.mainCategories = this.years[this.selectedYear]
            }
            
        },
        modalSelectedYear: function(){
            // Clear previously selected values
            this.modalPrograms = [];
            this.modalSelectedProgram = "";
            this.modalSelectedPeriod = "";
            // Populate list of mainCategories based on year in the second dropdown
            if (this.modalSelectedYear.length > 0){
                this.selectedYear=new Date().setUTCFullYear(this.modalSelectedYear);
                this.modalPrograms = this.years[this.selectedYear.getUTCFullYear()]['Providers']
                console.log("Adding modal programs")
                console.log(this.modalPrograms)
            }
        },
        selectedMainCategory: function(){
            //clear previously selected values
            this.subCategories = [];
            // Populate list of subCategories based on mainCategory and the year
            let selectedYear=new Date(this.modalSelectedYear).getUTCFullYear().toString();
            if (this.selectedMainCategory.length > 0){
                this.subCategories = this.years[selectedYear][this.selectedMainCategory]
            }
        },
        currentCommentsData: function(){
            console.log("Updating the data in commentary.vue")
            console.log(this.currentCommentsData)
            console.log(`local subCategory ${this.selectedSubCategory}, vuex subCategory ${this.currentCommentsSubCategory}`)
            console.log("###################################")
            this.commentsData = this.currentCommentsData.map(cmnt => ({
                ...cmnt,
                avatarBg: this.userAvatarPlaceHolders[Math.floor(Math.random() * this.userAvatarPlaceHolders.length)]
            }));
            this.selectedYear = this.currentCommentsYear;
            this.selectedMainCategory = this.currentCommentsMainCategory;
            this.selectedSubCategory = this.currentCommentsSubCategory;
            this.selectedPeriod = this.currentCommentsPeriod;
            //this.modalPrograms = [],
            //this.modalSelectedProgram = "",
           // this.modalSelectedYear = "",
           // this.modalSelectedPeriod = "",
            this.modalTextArea = "",
            this.waitingForData = false
            //this.displayYear = this.currentCommentsYear;
           // this.displayMainCategory = this.currentCommentsMainCategory;
           // this.displaySubCategory = this.currentCommentsSubCategory;
            //this.displayPeriod = this.currentCommentsPeriod;
            this.periodSelector = this.currentPeriodSelector;
        },
        currentCommentaryMenu: function(){
            
            this.years = this.currentCommentaryMenu;
            this.modalSelectedYear = (this.currentCommentsYear.length>0)?new Date(this.currentCommentsYear.toString(),1,1):''
            this.selectedMainCategory = this.currentCommentsMainCategory;
            this.selectedSubCategory = this.currentCommentsSubCategory;
            this.selectedPeriod = this.currentCommentsPeriod;
            this.periodSelector = this.currentPeriodSelector;
            var model = {
                        "mainCategory":this.selectedMainCategory,
                        "subCategory":this.selectedSubCategory,
                        "year":this.currentCommentsYear,
                        "period":this.selectedPeriod,
                    }
            var validation = this.validateViewComments()
            if(validation['status'] == true){
                this.waitingForData = true
                this.updateCommentaryParams({...model, periodSelector: this.periodSelector})
                this.getCommentsData()
                console.log(`initiating view comments with: ${JSON.stringify(model)}`)
            } else {
                console.log(`Cannot initialize view comments. ${JSON.stringify(model)}`)
            }
            
            // this.waitingForData = true
            // this.initialSetupCompleted = true
            // this.onSubmit()
            // this.getCommentsData()
            console.log(`initialized local subCategory ${this.selectedSubCategory}, vuex subCategory ${this.currentCommentsSubCategory}`)
                
            }
    },
    created(){
        this.getMenuOptions(true);
    }
}
</script>

<style scoped>
.deleteSelectAll {
    display: flex;
    margin-left: 12px;
    margin-top: 2px;
    justify-content: flex-start;
    align-items: baseline;
}
.delete-checkbox {
    position: absolute;
    top: 10px;
    left: 10px;
}
.vertical-radio-input {
    margin-right: 24px;
}
.comment-view-container {
    border: 0;
}
.btn-warning-arp {
    color: #000 !important;
    background-color: #FBC743 !important;
    font-weight: bold !important;

}
.btn-light-arp {
    color: #000 !important;
    background-color: #fff !important;
    font-weight: bold !important;
    border-radius: 5px;
}
.comments-top-actions {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.period-radio-group {
    display: flex;
    justify-content: space-between;
}
.no-display {
    display: none;
}
.subCategory-filter {
    margin-top: 10px;
    padding: 20px 11px;
    background-color: #F4F4F4;
    background-clip: border-box;
}
.format-pre {
  white-space: pre-wrap;
  word-break: keep-all;
  font-family: Arial;
  font-size: 16px;
}
.filter-label {
    font-weight: bold;
    margin-bottom: 15px;
}
.maincategory-input-group {
    display: flex;
    justify-content: space-between;
}
.maincategory-input:last-child {
    margin-right: 56px;
}
.maincategory-label {
    margin-bottom: 15px;
}
.maincategory-filter {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
.selection-container {
    display: flex;
    border-top: 3px solid #f4f4f4;
    flex-direction: column;
    justify-content: space-evenly;
    padding-top: 12px;
    margin-top: 4px;
}
.selection-title {
    display: flex;
    justify-content: space-between;
    margin: 2px 0px;
}
.menu-item {
    padding: 5px 10px;
    background-clip: border-box;
    cursor: pointer;
}
.menu-item:hover {
    background-color: #E7EAF2;
}
.comment-action-menu {
    background-color: #ffffff;
    width: 150px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-size: 14px;
    right: 0;
    position: absolute;
    box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
    z-index: 12;
}
.dot-menu {
    position: absolute;
    right: 0;
    width: 20px;
    cursor: pointer;
}
.dot {
    height: 4px;
    width: 4px;
    margin-bottom: 3px;
    background-color: #495057;
    border-radius: 50%;
    display: block;
}
.user-name-section {
    display: flex;
    align-items: center;

}
.avatar-circle {
  width: 33px;
  margin-right: 6px;
  height: 33px;
  text-align: center;
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
}
.initials {
  position: relative;
  font-size: 15px; /* 50% of parent */
  line-height: 33px; /* 50% of parent */
  color: #fff;
  font-weight: bold;
}
.lable-lite {
    color: #A4ADB3;
}
.main-comment {
    margin-top: 30px;
    min-height: 100px;
}
.comment-card-left-content {
    width: 18%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 140px;
    background-color: #FFFFFF;
}
.comment-card-right-content {
    margin-left: 25px;
    width: 75%;
}
.comment-right-top-menu {
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
}
.comment-card-body {
    color: #333333;
    min-height: 100px;
    display: flex;
    background-color: #FCFBFB;
    border-radius: 5px;
}
.comments-count {
    margin-left: 14px;
    font-size: 18px;
    font-weight: 500;
}
.comments-view-section {
    background-color: #eeeeee;
    margin: 0;
    padding: 0;
    padding-top: 24px;
    padding-bottom: 12px;
    padding-left: 20px;
    padding-right: 24px;
    min-height: calc(100vh - 174px);
}
.comments-title-section {
    top: 60px;
    left: 0px;
    width: 100%;
    height: 90px;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    opacity: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 20px;

}
.comments-title {
    margin-left: 28px;
    font-size: 26px;
    font-weight: 300;
}
.comments-container {
    font-family: Arial;
    font-size: 16px;
    height: 100%;
}
.dropdown {
    margin: 10px 0;
    padding: 10px 0;
    border-bottom: 1px solid #DDD;
    border-radius:10px;
}
.someclass {
   overflow-y: auto;
   max-height: 705px;
}
.dropdown span {
    display:inline-block;
    width: 80px;
}
.main-btn {
    background-color: #FBC743;
    color: black;
}
.radio {
  position: relative;
  cursor: pointer;
  line-height: 16px;
  font-size: 14px;
  display: flex;
}
.radio .label {
  position: relative;
  display: block;
  float: left;
  margin-right: 5px;
  width: 14px;
  height: 14px;
  border: 1px solid gray;
  border-radius: 100%;
}
.radio .label:after {
  content: '';
  position: absolute;
  top: 3px;
  left: 3px;
  width: 6px;
  height: 6px;
  border-radius: 100%;
  background: #000000;
  opacity: 0;
  pointer-events: none;
}
input[type="radio"]:checked + .label {
  border-color: #000000;
}
input[type="radio"]:checked + .label:after {
  transform: scale(1);
  opacity: 1;
}
.cntr {
  position: absolute;
  top: calc(50% - 5px);
  left: 0;
  width: 100%;
  text-align: center;
}
.hidden {
  display: none;
}
.credit {
  position: fixed;
  right: 16px;
  bottom: 16px;
  -webkit-user-select: none;
  user-select: none;
  opacity: 0.6;
}
.b-card{
    border-radius: 5px;
    margin-bottom:2%;
}
.leftContent{
    background-color:#ffffff;
    padding-left:45px;
    padding-bottom:10px;
    padding-top:30px; 
    border-radius: 5px 0px 0px 5px;
}
.middleContent{
    padding-top:30px;
    background-color:#FCFBFB;
    z-index:10;
}
.middleContent-corner{
    float:right;
    margin-right:-80px;
    padding-top:20px;
}
.rightContent{
    padding-top:15px;
    background-color:#FCFBFB;
}

.noResultContainer {
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    align-items: center;
    height: max-content;
    margin-top: 10%;
}

.commentLatestEdit {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin: 0px 8px 8px 0px
}

.commentLatestEdit .time-white {
    width: 30px;
    margin-bottom: 2px;
    margin-right: 4px;
    margin-left: 0px;
}

.commentLatestEdit .editorName {
    font-weight: 500;
}

.commentLatestEdit .editorEmail {
    font-size: 14px;
    margin-left: 4px;
}
</style>
